import React from "react";
import { Input } from "@/components/ui/input";

// Formats whole-number Rupiah amounts with thousand separators (titik) while typing —
// e.g. "1000000" displays as "1.000.000". The value/onChange contract stays identical
// to a plain <Input type="number">: onChange still receives a plain digit string via
// e.target.value, so callers don't need to change their state/parsing logic at all.
const formatId = (raw) => {
  if (raw === "" || raw === null || raw === undefined) return "";
  const digits = String(raw).replace(/[^\d]/g, "");
  if (!digits) return "";
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export default function NumberInput({ value, onChange, ...props }) {
  const handleChange = (e) => {
    const digits = e.target.value.replace(/[^\d]/g, "");
    onChange({ target: { value: digits } });
  };
  return (
    <Input
      {...props}
      type="text"
      inputMode="numeric"
      value={formatId(value)}
      onChange={handleChange}
    />
  );
}
